import { render, staticRenderFns } from "./LoadingUI.vue?vue&type=template&id=b21b490a&scoped=true&"
import script from "./LoadingUI.vue?vue&type=script&lang=js&"
export * from "./LoadingUI.vue?vue&type=script&lang=js&"
import style0 from "./LoadingUI.vue?vue&type=style&index=0&id=b21b490a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21b490a",
  null
  
)

export default component.exports